import {debounce} from 'lodash';
import {useRef, useState} from 'react';
import {
  TwitchExtensionConfiguration,
  usePulsoidClient,
} from '../../PulsoidClient';
import {useEffectFirstSkip} from '../../utils/useEffectFirstSkip';
import css from './TwitchExtensionConfiguration.module.scss';

type TwitchExtensionStreamDelayComponentProps = {
  configuration: TwitchExtensionConfiguration;
};

const UnsignedInt = /^\d+$/;
export const TwitchExtensionStreamDelayComponent = (
  props: TwitchExtensionStreamDelayComponentProps
) => {
  let [streamDelayMilliseconds, setStreamDelayMilliseconds] = useState(
    props.configuration.streamDelayMilliseconds
  );

  let updateStreamDelay = useDebouncedStreamDelayUpdate();

  useEffectFirstSkip(() => {
    async function perform() {
      let response = await updateStreamDelay(streamDelayMilliseconds);
      //setStreamDelayMilliseconds(
      //  response?.configuration.streamDelayMilliseconds ?? 0
      //);
    }
    perform();
  }, [streamDelayMilliseconds]);

  return (
    <div className={css.stream_delay_container}>
      Stream delay
      <input
        pattern="^\d+$"
        type={'number'}
        min={0}
        step={1}
        value={streamDelayMilliseconds / 1000}
        onChange={(e) => {
          let value = e.target.value;
          if (UnsignedInt.test(value)) {
            setStreamDelayMilliseconds(Number(e.target.value) * 1000);
          }
        }}
      />
      seconds
    </div>
  );
};

const useDebouncedStreamDelayUpdate = () => {
  let client = usePulsoidClient();
  let debounced = useRef(
    debounce(
      (streamDelayMilliseconds) =>
        client.updateTwitchExtensionStreamDelay(streamDelayMilliseconds),
      300
    )
  );
  return debounced.current;
};
